import { isNil } from 'lodash'
import { compose } from 'ramda'

const toAuthorizationHeaders = (bearer) => {
  let header = { Authorization: bearer }
  const maModeKey = localStorage.getItem('maModeKey')
  if (!isNil(maModeKey)) {
    header = { ...header, 'x-mode-key': maModeKey }
  }
  return header
}
const toBearer = (accessToken) => `Bearer ${accessToken}`
export const accessTokenToAuthorizationHeaders = compose(
  toAuthorizationHeaders,
  toBearer,
)

const toAuthorizationHeadersAndXMode = (result) => {
  let header = { Authorization: result.accessToken }
  const maModeKey = localStorage.getItem('maModeKey')
  if (!isNil(maModeKey)) {
    header = { ...header, 'x-mode-key': maModeKey }
  }
  return header
}

const toBearerXMode = (result) => ({
  accessToken: `Bearer ${result.accessToken}`,
  xModeKey: localStorage.getItem('maModeKey'),
})

const toHeaderXModeOnly = () => ({
  'x-mode-key': localStorage.getItem('maModeKey'),
})

export const accessTokenToAuthorizationHeadersXMode = compose(
  toAuthorizationHeadersAndXMode,
  toBearerXMode,
)

export const accessAuthorizationHeadersXModeOnly = compose(toHeaderXModeOnly)
